import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectPropertiesPage } from '../components/ProjectPropertiesPage';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/project-properties')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: ProjectPropertiesSettingsComponent,
});

function ProjectPropertiesSettingsComponent() {
  return <ProjectPropertiesPage />;
}
